import { useCallback, useState, memo, useEffect, useMemo } from 'react';
import { Row, Col, Popover } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BzPopoverOverlay, BzChip } from "../../components";
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { getOrderInfo, getScripOrderInfo, updateExitOrderData } from '../../redux/actions/orders';
import { convertScripResponseWatchlistGrid, getArrSingleScripOrderInfo, getChangeInRs, getDecimalLocatorFromApiExchangeName, getDynamicParamsForToFixed, getMappedMktSegIdFromApiExchangeName, getOrderDisplayDiscription, ORDER_ENTRY_GRID_REF, ORDERS_GRID_REF } from '../../utils/global_functions';
import { ALL_ORDERS_STATUS, ORDER_TYPES, ORDER_VALIDITY, TL_INDEX, WATCHLIST_GRID_INDEX, FACILITY_NUM, SCRIP_INSTRUMENTS, ORDER_STATUS_FROM_RESPONSE, MARKET_SEGMENT_ID, ORDER_PRODUCT_TYPES, ORDER_ENTRY_TYPES, ORDER_ENTRY_BUTTON_TOGGLE, TRADING_NOT_ALLOWED_MSG } from '../../utils/global_variables';
import { useWFHMessages, useLeftClick } from '../../hooks';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';
import DontMissChip from '../DontMiss/DontMissChip';
import { sendBestFiveRequest } from '../../apis/web_socket';
import { setScripOverviewData } from '../../redux/actions/marketOverview';
import { _checkSegmetAllowed, _getScripsInfo } from '../../controllers';
import OrderDisplayDescription from './OrderDisplayDescription';
import dayjs from 'dayjs';
import moment from 'moment';
import { toastConfig } from '../../redux/actions/toast';

//Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
const OrdersPopover = ({ children, placement = 'right', activeContent, ...props }) => {
    //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End

    const objRowDataFromGrid = props?.node?.data;
    const dispatch = useDispatch();
    const [showPopover, setShowPopover] = useState(false);
    const [objScripData, setObjScripData] = useState({});
    const [currentHolding, setCurrentHolding] = useState([]);
    const [holdingInfo, setHoldingInfo] = useState([]);
    const holdingsScrips = useSelector(state => state.holdings?.holdingsScrips);
    //Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments - Start
    const bIsMultipleOrdersCancelinProcess = useSelector(state => state.orders?.bIsMultipleOrdersCancelinProcess);
    //Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments - End
    const objCFT = useSelector(state => state?.auth?.objCFT);//ManasaB : 23/11/2023 : BT-115296 Calculator Bug Fixing
    const showTradeInfo = (orderNo) => {
        setShowPopover(false);
        ORDERS_GRID_REF.current.api.forEachNode(node => {
            if (node?.data?.orderNo === orderNo) {
                ORDERS_GRID_REF.current.api.setRowNodeExpanded(node, true, true);
            }
        });
    };
    //Azeem K : 16-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
    useEffect(() => {
        if (holdingsScrips?.length) {
            holdingsScrips?.forEach((item) => {
                //Vaibhav Singh: Holding icon removed from order book: Start
                if (item?.TOTALFREEQUANTITY !== "0" && item['ISIN'] === objRowDataFromGrid?.sISINCode && objRowDataFromGrid?.instrument === SCRIP_INSTRUMENTS.EQUITIES
                ) {
                    setCurrentHolding([item]);
                }
            });
        }
    }, [holdingsScrips, objRowDataFromGrid]);
    // Azeem K : 16-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
    useEffect(() => {
        if (currentHolding?.length) {
            if (currentHolding[0]?.nBuyAvgPrice) {
                let arrNetChangePNL = getChangeInRs((objScripData?.ltp * currentHolding[0]['TOTALFREEQUANTITY']).toFixed(2), (parseFloat(currentHolding[0]?.nBuyAvgPrice) * parseInt(currentHolding[0]?.TOTALFREEQUANTITY)).toFixed(2), 2, false, 'uptrend');
                setHoldingInfo(arrNetChangePNL);
            }
        }
    }, [currentHolding, objScripData]);

    //ManasaB : 13-06-2024 : Changed to left click in grid :Start
    const leftClick = useCallback((e) => {
        if (e?.button === 0) {
            setShowPopover(false);
        }
    }, []);
    const [targetobjRowData] = useLeftClick(leftClick);
    //ManasaB : 13-06-2024 : Changed to left click in grid : End
    const onContextMenu = (e) => {
        if (e?.ctrlKey) {
            return;
        }
        e.preventDefault();
        //Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments - Start
        if (!bIsMultipleOrdersCancelinProcess) {
            setShowPopover(true);
        }
        //Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments - End
    };

    // useEffect(() => {
    //     if (location?.state?.length > 0) {
    //         const nIndex = ORDERS_GRID_REF?.current?.api?.getRowNode(location?.state)?.rowIndex;
    //         ORDERS_GRID_REF?.current?.api?.getDisplayedRowAtIndex(nIndex)?.setSelected(true);
    //         ORDERS_GRID_REF?.current?.api?.getDisplayedRowAtIndex(nIndex).setExpanded(true);
    //         setShowPopover(false);
    //     } else { }
    // }, [location.state]);

    const handleCancelOrder = useCallback(() => {
        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
        // const scripData = getArrSingleScripOrderInfo(objRowDataFromGrid);
        // const isBuySell = objRowDataFromGrid?.type === "BUY" ? 0 : 1;
        dispatch(getOrderInfo(objRowDataFromGrid));
        // dispatch(getScripOrderInfo({ isBuySell, activeExchangeId: scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData }));
        dispatch(handleModal([{ 'CANCEL_ORDER_MODAL': true }], true));
        setShowPopover(false);
        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
    }, [dispatch, objRowDataFromGrid]);
    const objLoginSession = useSelector(state => state.auth.objLoginSession);

    const handleModifyOrder = () => {
        if (_checkSegmetAllowed(objRowDataFromGrid?.exchangeSegment, objLoginSession?.data?.exchanges)) {

            setShowPopover(false);
            const scripData = getArrSingleScripOrderInfo(objRowDataFromGrid);
            //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
            let isBuySell = (objRowDataFromGrid?.type || objRowDataFromGrid?.transaction_type) === "BUY" ? 0 : 1;
            if (scripData[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES || scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_DERIVATIVES || scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES
                //Azeem K : 01-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSE FnO Bug Fixes - Start
                || scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSE_DERIVATIVES) {
                //Azeem K : 01-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSE FnO Bug Fixes - End
                var nQuantity = objRowDataFromGrid?.pendingQuantity;
                var nLot = parseInt(objRowDataFromGrid?.pendingQuantity) / scripData[WATCHLIST_GRID_INDEX.REGULAR_LOT];
            } else {
                nLot = objRowDataFromGrid?.pendingQuantity;
                nQuantity = parseInt(objRowDataFromGrid?.pendingQuantity) * scripData[WATCHLIST_GRID_INDEX.REGULAR_LOT];
            }
            //Azeem K : 23-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NCDEX bug fixing - Start
            let nDisclosedQty = objRowDataFromGrid?.disclosed_quantity;
            if (scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES) {
                nDisclosedQty = parseInt(objRowDataFromGrid?.disclosed_quantity) / scripData[WATCHLIST_GRID_INDEX.REGULAR_LOT];
            }
            //Azeem K : 23-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NCDEX bug fixing - End
            // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -Start
            //add GTT validity condition
            if (objRowDataFromGrid?.validity === ORDER_VALIDITY.GTD || objRowDataFromGrid?.validity_date || objRowDataFromGrid?.validity === ORDER_VALIDITY.GTT) {
                // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --Start
                const isOCOChecked = !!Number(objRowDataFromGrid?.target_price) && !!Number(objRowDataFromGrid?.target_trigger_price);
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: objRowDataFromGrid?.price, slTrigger: objRowDataFromGrid?.trigger_price, scripQuantity: nQuantity, scripLot: nLot, slTrigger: objRowDataFromGrid?.trigger_price, gtdDate: dayjs(moment(objRowDataFromGrid?.validity_date).format('DD-MM-YYYY'), 'DD-MM-YYYY'), discQty: nDisclosedQty, targetSelPrice: objRowDataFromGrid?.target_price ? objRowDataFromGrid?.target_price : 0, targetSelTriggerPrice: objRowDataFromGrid?.target_trigger_price ? objRowDataFromGrid?.target_trigger_price : 0 }));
                ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(curr => ({ ...curr, productType: objRowDataFromGrid?.product_type || objRowDataFromGrid?.prodType, productTypeDesc: objRowDataFromGrid?.prodTypeDesc || objRowDataFromGrid?.productTypeDesc, validityTypes: objRowDataFromGrid?.validity === ORDER_VALIDITY.GTT ? objRowDataFromGrid?.validity : ORDER_VALIDITY.GTD, orderType: objRowDataFromGrid?.order_type || objRowDataFromGrid?.orderType, isAmo: objRowDataFromGrid?.is_amo_order, isOCOChecked: isOCOChecked, isDefaultProductType: false }));
                // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --End
                // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -End
                //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
            } else {
                // Azeem K : 11-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: objRowDataFromGrid?.price, scripQuantity: nQuantity, slTrigger: objRowDataFromGrid?.trigger_price, scripLot: nLot, discQty: nDisclosedQty }));
                ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(curr => ({ ...curr, productType: objRowDataFromGrid?.prodType, productTypeDesc: objRowDataFromGrid?.productTypeDesc, validityTypes: objRowDataFromGrid?.validity, orderType: objRowDataFromGrid?.orderType, isAmo: objRowDataFromGrid?.is_amo_order, isDefaultProductType: false }));
                // Azeem K : 11-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
            }
            //  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start
            if (objRowDataFromGrid?.prodType === ORDER_PRODUCT_TYPES.BRACKET) {
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: objRowDataFromGrid?.order_price, intradayLimit: objRowDataFromGrid?.bracket_details?.stoploss_price, intradayTrigger: objRowDataFromGrid?.bracket_details.stoploss_trigger_price, intradayProfit: objRowDataFromGrid?.bracket_details?.profit_price ? objRowDataFromGrid?.bracket_details?.profit_price : 0, intradayTrailing: objRowDataFromGrid?.bracket_details?.stoploss_jump_price ? objRowDataFromGrid?.bracket_details?.stoploss_jump_price : 0, IntradayChangePrice: objRowDataFromGrid?.bracket_details?.ltp_jump_price ? objRowDataFromGrid?.bracket_details?.ltp_jump_price : 0 }));
                ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(curr => ({ ...curr, productType: objRowDataFromGrid?.modifyReorderProductType, productTypeDesc: objRowDataFromGrid?.modifyReorderProductTypeDescr, orderType: objRowDataFromGrid?.orderType === ORDER_ENTRY_TYPES.SL ? ORDER_ENTRY_TYPES.RL : objRowDataFromGrid?.orderType }));
                ORDER_ENTRY_GRID_REF?.current?.setToggleBracketOrder(curr => ({ ...curr, isShow: true, strProductType: objRowDataFromGrid?.prodType }));

                if (objRowDataFromGrid?.bracket_details.leg_indicator !== "Main Leg") {
                    if (isBuySell === ORDER_ENTRY_BUTTON_TOGGLE.SELL) {
                        isBuySell = ORDER_ENTRY_BUTTON_TOGGLE.BUY;
                    }
                    else {
                        isBuySell = ORDER_ENTRY_BUTTON_TOGGLE.SELL;
                    }
                }
            } else if (objRowDataFromGrid?.prodType === ORDER_PRODUCT_TYPES.COVER) {
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: objRowDataFromGrid?.order_price, intradayLimit: objRowDataFromGrid?.bracket_details?.stoploss_price, intradayTrigger: objRowDataFromGrid?.bracket_details.stoploss_trigger_price, }));
                ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(curr => ({ ...curr, productType: objRowDataFromGrid?.modifyReorderProductType, productTypeDesc: objRowDataFromGrid?.modifyReorderProductTypeDescr, orderType: objRowDataFromGrid?.orderType === ORDER_ENTRY_TYPES.SL ? ORDER_ENTRY_TYPES.RL : objRowDataFromGrid?.orderType }));
                ORDER_ENTRY_GRID_REF?.current?.setToggleBracketOrder(curr => ({ ...curr, isShow: true, strProductType: objRowDataFromGrid?.prodType }));
                if (!objRowDataFromGrid?.cover_modify_main_qty) {
                    if (isBuySell === ORDER_ENTRY_BUTTON_TOGGLE.SELL) {
                        isBuySell = ORDER_ENTRY_BUTTON_TOGGLE.BUY;
                    }
                    else {
                        isBuySell = ORDER_ENTRY_BUTTON_TOGGLE.SELL;
                    }
                }
            }

            //  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - End
            //  Azeem K : 29-04-2025 : BREEZE-6539 - Breeze - Bracket Orders - Start
            //LLD comment : modification logic will be write here for bracket order
            //  Azeem K : 29-04-2025 : BREEZE-6539 - Breeze - Bracket Orders - End
            dispatch(getScripOrderInfo({ isBuySell, activeExchangeId: scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData, isModifyOrder: true, nOriginalQty: nQuantity }));
            dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }], true));
            // Vaibhav SIngh: BT-102298: 09-02-24: Modal Grid modify quamtity solved: Start
            // {/* Vinit Raut : 27-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start  */ }
            dispatch(handleModalData({ orderData: objRowDataFromGrid, orderType: ORDER_TYPES.SINGLE_SCRIP }));
            // {/* Vinit Raut : 27-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- End  */ }
            // Vaibhav SIngh: BT-102298: 09-02-24: Modal Grid modify quamtity solved: End
        } else {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: TRADING_NOT_ALLOWED_MSG }));

        }
    };

    useEffect(() => {
        const objLastTickData = dispatch(getWfhTouchlineLastTick());
        const arrLastTickData = objLastTickData[objRowDataFromGrid?.mktId + '_' + objRowDataFromGrid?.scripToken];
        if (arrLastTickData) {
            let nAbsPrevColse = arrLastTickData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
            setObjScripData({
                ltp: arrLastTickData[TL_INDEX.LAST_TRADE_PRICE],
                //Maaz A : 04-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
                changeInPrice: nAbsPrevColse,
                //Maaz A : 04-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
                changeInPercent: arrLastTickData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE]
            });
        }
        // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue - LTP and change in price not displaying – Start
        else {
            setObjScripData({
                ltp: parseFloat(0).toFixed(objRowDataFromGrid?.decimalLocatorLength),
                changeInPrice: parseFloat(0).toFixed(objRowDataFromGrid?.decimalLocatorLength),
                changeInPercent: '0.00'
            });
        }
        // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue - LTP and change in price not displaying – End


    }, [dispatch, objRowDataFromGrid?.decimalLocatorLength, objRowDataFromGrid?.mktId, objRowDataFromGrid?.scripToken]);

    //Maaz A : 09-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
    useWFHMessages('touchline', (e) => {
        const arrTouchlineData = [...e.detail];
        if (arrTouchlineData[TL_INDEX.SEGMENT_ID] === objRowDataFromGrid?.mktId && arrTouchlineData[TL_INDEX.TOKEN] === objRowDataFromGrid?.scripToken) {
            let nAbsPrevColse = arrTouchlineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
            setObjScripData({
                ltp: arrTouchlineData[TL_INDEX.LAST_TRADE_PRICE],
                changeInPrice: nAbsPrevColse,
                changeInPercent: arrTouchlineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE]
            });
        }
    });
    //Maaz A : 09-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End

    // {/* Azeem k :09-11-2023 :code commented as per discussion with akshay square off will be remove code will remove later */ }
    // const handleSquareOffPosition = useCallback(() => {
    //     setShowPopover(false);

    //     dispatch(handleModalData({ data: objRowDataFromGrid, type: 'Single Square Off' }));
    //     dispatch(handleModal([{ "ORDER_DETAILS_MODAL": true }], true));
    // }, [objRowDataFromGrid, dispatch]);
    // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
    const bIsCancelButton = useMemo(() => {
        return objRowDataFromGrid?.status === ORDER_STATUS_FROM_RESPONSE.PENDING || objRowDataFromGrid?.status === ORDER_STATUS_FROM_RESPONSE.PARTIALLYCOMPLETED_MAIN || objRowDataFromGrid?.status === ALL_ORDERS_STATUS.PARTIALLY_COMPLETED || objRowDataFromGrid?.status === ORDER_STATUS_FROM_RESPONSE.OMS_XMITTED || objRowDataFromGrid?.status === ORDER_STATUS_FROM_RESPONSE.OMSXMITTED_MAIN || objRowDataFromGrid?.status === ORDER_STATUS_FROM_RESPONSE.ACTIVE || objRowDataFromGrid?.status === ORDER_STATUS_FROM_RESPONSE.AMOACCEPTED || objRowDataFromGrid?.status === ORDER_STATUS_FROM_RESPONSE.AMOACCEPTED_MAIN;
    }, [objRowDataFromGrid]);

    const bIsModifyButton = useMemo(() => {
        if (objRowDataFromGrid?.prodType === ORDER_PRODUCT_TYPES.COVER) {
            return objRowDataFromGrid?.cover_modify;
        } if (objRowDataFromGrid?.prodType === ORDER_PRODUCT_TYPES.BRACKET) {
            return objRowDataFromGrid?.bracket_details.bo_order_status === ORDER_STATUS_FROM_RESPONSE.PENDING && !objRowDataFromGrid['Exit Leg'] && !objRowDataFromGrid?.modifyOrderDisabled;
        } else {
            return objRowDataFromGrid?.status === ORDER_STATUS_FROM_RESPONSE.PENDING || objRowDataFromGrid?.status === ORDER_STATUS_FROM_RESPONSE.PARTIALLYCOMPLETED_MAIN || objRowDataFromGrid?.status === ORDER_STATUS_FROM_RESPONSE.AMOACCEPTED_MAIN || objRowDataFromGrid?.status === ORDER_STATUS_FROM_RESPONSE.ACTIVE;
        }
    }, [objRowDataFromGrid]);
    // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End

    const bIsReorderButton = useMemo(() => {
        if (objRowDataFromGrid?.prodType === ORDER_PRODUCT_TYPES.COVER) {
            return objRowDataFromGrid?.cover_reorder;
        } else {
            return true;
        }
    }, [objRowDataFromGrid]);

    const bIsConvertPositionButton = useMemo(() => {
        if (objRowDataFromGrid?.prodType === ORDER_PRODUCT_TYPES.BRACKET) {
            return (objRowDataFromGrid?.mainLegStatus === ORDER_STATUS_FROM_RESPONSE.EXECUTED && objRowDataFromGrid?.bracket_details.bo_order_status !== ORDER_STATUS_FROM_RESPONSE.COMPLETED && objRowDataFromGrid?.bracket_details.bo_order_status !== ORDER_STATUS_FROM_RESPONSE.CONVERTED) ||
                ((objRowDataFromGrid?.mainLegStatus === ORDER_STATUS_FROM_RESPONSE.PENDING || objRowDataFromGrid?.mainLegStatus === ORDER_STATUS_FROM_RESPONSE.PARTIALLYCOMPLETED_MAIN) && objRowDataFromGrid?.bracket_details?.leg_indicator && objRowDataFromGrid?.bracket_details?.leg_indicator === 'Main Leg' && objRowDataFromGrid?.traded_quantity > 0);
        } else {
            return false;
        }
    }, [objRowDataFromGrid]);

    const bIsExpandButton = useMemo(() => {
        if (activeContent === ORDER_TYPES.GOOD_TILL_DATE) {
            return objCFT?.GTTSUPPORT === FACILITY_NUM.OFF;
        } else {
            return true;
        }
    }, [objCFT, activeContent]);

    // {/* Azeem k :09-11-2023 :code commented as per discussion with akshay square off will be remove code will remove later */ }
    // const bIsSquareOffButton = useMemo(() => {
    //     return objRowDataFromGrid?.status === ALL_ORDERS_STATUS.ORDER_STATUS_COMPLETED || objRowDataFromGrid?.status === ALL_ORDERS_STATUS.ORDER_STATUS_EXECUTED;
    // }, [objRowDataFromGrid]);


    const handleReOrder = useCallback(() => {
        if (_checkSegmetAllowed(objRowDataFromGrid?.exchangeSegment, objLoginSession?.data?.exchanges)) {

            setShowPopover(false);
            const scripData = getArrSingleScripOrderInfo(objRowDataFromGrid);
            //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
            let isBuySell = (objRowDataFromGrid?.type || objRowDataFromGrid?.transaction_type) === "BUY" ? 0 : 1;
            if (scripData[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES || scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_DERIVATIVES || scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES
                //Azeem K : 01-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSE FnO Bug Fixes - Start
                || scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSE_DERIVATIVES) {
                //Azeem K : 01-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSE FnO Bug Fixes - End
                var nQuantity = objRowDataFromGrid?.totalQuantity;
                var nLot = parseInt(objRowDataFromGrid?.totalQuantity) / scripData[WATCHLIST_GRID_INDEX.REGULAR_LOT];
            } else {
                nLot = objRowDataFromGrid?.totalQuantity;
                nQuantity = parseInt(objRowDataFromGrid?.totalQuantity) * scripData[WATCHLIST_GRID_INDEX.REGULAR_LOT];
            }
            //Azeem K : 23-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NCDEX bug fixing - Start
            let nDisclosedQty = objRowDataFromGrid?.disclosed_quantity;
            if (scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES) {
                nDisclosedQty = parseInt(objRowDataFromGrid?.disclosed_quantity) / scripData[WATCHLIST_GRID_INDEX.REGULAR_LOT];
            }
            //Azeem K : 23-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NCDEX bug fixing - End
            // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -Start
            //add GTT validity condition
            if (objRowDataFromGrid?.validity === ORDER_VALIDITY.GTD || objRowDataFromGrid?.validity === ORDER_VALIDITY.GTT || objRowDataFromGrid?.validity_date) {
                // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --Start
                const isOCOChecked = !!Number(objRowDataFromGrid?.target_price) && !!Number(objRowDataFromGrid?.target_trigger_price);
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: objRowDataFromGrid?.price, scripQuantity: nQuantity, slTrigger: objRowDataFromGrid?.trigger_price, scripLot: nLot, gtdDate: objRowDataFromGrid?.validity_date ? dayjs(moment(objRowDataFromGrid?.validity_date).format('DD-MM-YYYY'), 'DD-MM-YYYY') : '', discQty: nDisclosedQty, targetSelPrice: objRowDataFromGrid?.target_price ? objRowDataFromGrid?.target_price : 0, targetSelTriggerPrice: objRowDataFromGrid?.target_trigger_price ? objRowDataFromGrid?.target_trigger_price : 0 }));
                ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(curr => ({ ...curr, productType: objRowDataFromGrid?.product_type || objRowDataFromGrid?.prodType, productTypeDesc: objRowDataFromGrid?.prodTypeDesc || objRowDataFromGrid?.productTypeDesc, validityTypes: objRowDataFromGrid?.validity === ORDER_VALIDITY.GTT ? objRowDataFromGrid?.validity : ORDER_VALIDITY.GTD, orderType: objRowDataFromGrid?.order_type || objRowDataFromGrid?.orderType, isAmo: objRowDataFromGrid?.is_amo_order, isDefaultProductType: false, isOCOChecked: isOCOChecked, }));
                // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --End
                // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025  -End
            } else {
                //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
                // Azeem K : 11-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: objRowDataFromGrid?.price, scripQuantity: nQuantity, slTrigger: objRowDataFromGrid?.trigger_price, scripLot: nLot, discQty: nDisclosedQty }));
                ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(curr => ({ ...curr, productType: objRowDataFromGrid?.prodType, productTypeDesc: objRowDataFromGrid?.productTypeDesc, validityTypes: objRowDataFromGrid?.validity, orderType: objRowDataFromGrid?.orderType, isAmo: objRowDataFromGrid?.is_amo_order, isDefaultProductType: false }));
            }
            // Azeem K : 11-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
            //  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start
            if (objRowDataFromGrid?.prodType === ORDER_PRODUCT_TYPES.BRACKET) {
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, intradayLimit: objRowDataFromGrid?.bracket_details?.stoploss_price, intradayTrigger: objRowDataFromGrid?.bracket_details?.stoploss_trigger_price, intradayProfit: objRowDataFromGrid?.bracket_details?.profit_price ? objRowDataFromGrid?.bracket_details?.profit_price : 0, intradayTrailing: objRowDataFromGrid?.bracket_details?.stoploss_jump_price ? objRowDataFromGrid?.bracket_details?.stoploss_jump_price : 0, IntradayChangePrice: objRowDataFromGrid?.bracket_details?.ltp_jump_price ? objRowDataFromGrid?.bracket_details?.ltp_jump_price : 0 }));
                ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(curr => ({ ...curr, productType: objRowDataFromGrid?.modifyReorderProductType, productTypeDesc: objRowDataFromGrid?.modifyReorderProductTypeDescr, orderType: objRowDataFromGrid?.orderType === ORDER_ENTRY_TYPES.SL ? ORDER_ENTRY_TYPES.RL : objRowDataFromGrid?.orderType }));
                ORDER_ENTRY_GRID_REF?.current?.setToggleBracketOrder(curr => ({ ...curr, isShow: true, strProductType: objRowDataFromGrid?.prodType }));
                if (objRowDataFromGrid?.bracket_details.leg_indicator !== "Main Leg") {
                    if (isBuySell === ORDER_ENTRY_BUTTON_TOGGLE.SELL) {
                        isBuySell = ORDER_ENTRY_BUTTON_TOGGLE.BUY;
                    }
                    else {
                        isBuySell = ORDER_ENTRY_BUTTON_TOGGLE.SELL;
                    }
                }
            } else if (objRowDataFromGrid?.prodType === ORDER_PRODUCT_TYPES.COVER) {
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, intradayLimit: objRowDataFromGrid?.bracket_details?.stoploss_price, intradayTrigger: objRowDataFromGrid?.bracket_details?.stoploss_trigger_price }));
                ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(curr => ({ ...curr, productType: objRowDataFromGrid?.modifyReorderProductType, productTypeDesc: objRowDataFromGrid?.modifyReorderProductTypeDescr }));
                ORDER_ENTRY_GRID_REF?.current?.setToggleBracketOrder(curr => ({ ...curr, isShow: true, strProductType: objRowDataFromGrid?.prodType }));
            }
            //  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - End


            dispatch(getScripOrderInfo({ isBuySell, activeExchangeId: scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData, isReOrder: true }));
            dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }], true));

        } else {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: TRADING_NOT_ALLOWED_MSG }));

        }
    }, [objRowDataFromGrid, dispatch]);

    const handleOverview = async () => {
        setShowPopover(false);
        const arrRowData = getArrSingleScripOrderInfo(objRowDataFromGrid);
        const scripDataRes = await _getScripsInfo([{ mkt: arrRowData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], token: arrRowData[WATCHLIST_GRID_INDEX.TOKEN] }]);
        const scripDataObj = scripDataRes?.data?.objScripsResp?.result;
        const scripData = convertScripResponseWatchlistGrid(scripDataObj);
        sendBestFiveRequest({ exchangeId: scripData?.[0]?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scripData?.[0]?.[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true });
        dispatch(setScripOverviewData(scripData?.[0]));
        dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }]));
    };
    // {/* Azeem K : 19-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start */ }
    const handleSetAlert = () => {
        setShowPopover(false);
        dispatch(handleModalData({
            AlertData: {
                symbol: objRowDataFromGrid?.title,
                exchange: objRowDataFromGrid?.exchange?.split('_')[0],
                series: objRowDataFromGrid?.series,
                description: getOrderDisplayDiscription(objRowDataFromGrid),
                token: objRowDataFromGrid?.scripToken,
                mktId: objRowDataFromGrid?.mktId,
                decimalLocator: getDecimalLocatorFromApiExchangeName(objRowDataFromGrid?.exchange),
                decimalLocator_length: getDynamicParamsForToFixed(objRowDataFromGrid?.exchange),
                exchange_segement: objRowDataFromGrid?.exchangeSegment,
                expiryDate: objRowDataFromGrid?.expiryDate,
                mappedMktId: getMappedMktSegIdFromApiExchangeName(objRowDataFromGrid?.exchange),
                instrument: objRowDataFromGrid?.instrument,
            },
            isShowAlerts: true
        }));
        dispatch(handleModal([{ "SET_ALERT_MODAL": true }]));
    };
    // {/* Azeem K : 19-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End */ }

    //    Azeem K : 08-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start
    const bISExitButton = useMemo(() => {
        //for showing conditionally exit button
        if ((objRowDataFromGrid?.prodType === ORDER_PRODUCT_TYPES.COVER) &&
            objRowDataFromGrid?.cover_exit) {
            return true;
        } else if (objRowDataFromGrid?.prodType === ORDER_PRODUCT_TYPES.BRACKET) {
            return objRowDataFromGrid?.bracket_details.bo_order_status === ORDER_STATUS_FROM_RESPONSE.PENDING && !objRowDataFromGrid['Exit Leg'];
        } else {
            return false;
        }
    }, [objRowDataFromGrid]);
    const handleExit = () => {
        // onclick function of exit button
        setShowPopover(false);
        dispatch(handleModal([{ "EXIT_OR_CONVERT_POSITION_ORDER_MODAL": true }]));
        dispatch(updateExitOrderData({ objExitOrderData: objRowDataFromGrid, modalType: 'exit' }));


    };

    const handleConvertPosition = () => {
        setShowPopover(false);
        dispatch(handleModal([{ "EXIT_OR_CONVERT_POSITION_ORDER_MODAL": true }]));
        dispatch(updateExitOrderData({ objExitOrderData: objRowDataFromGrid, modalType: 'convert_position' }));

    };
    // Azeem K : 08-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start



    const BzPopover = (
        <Popover className='scripdetails-popover'>
            <Popover.Header>
                <div className='p-2'>
                    <Row className='g-0'>
                        <Col md={7}>
                            <Row className='g-0'>
                                <Col className='d-flex align-items-center'>
                                    <div className='font-medium font-size4 color-text text-truncate me-2'>{objRowDataFromGrid?.title}</div>
                                    <div className='chips-wrap'>
                                        <BzChip className='exchange-chip text-truncate'>{objRowDataFromGrid?.exchange?.split('_')[0]}</BzChip>
                                    </div>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <Col className='d-flex justify-content-start'>
                                    <div className='font-regular font-size3 color-subtext'>
                                        {/* Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start */}
                                        <OrderDisplayDescription objRowData={objRowDataFromGrid} />
                                        {/* Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End */}
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={5}>
                            <Row className='g-0'>
                                <Col className='flex-column justify-content-start align-items-end text-end'>
                                    <div className='font-medium font-size4 color-text'>{objScripData?.ltp}</div>
                                    <div className={`font-regular font-size2 color-text color-${objScripData?.changeInPrice?.split('')[0] === '+' ? 'positive' : objScripData?.changeInPrice?.split('')[0] === '-' ? 'negative' : ''} ms-1`} >{objScripData?.changeInPrice} ({objScripData?.changeInPercent}%)</div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </Popover.Header>
            <Popover.Body className='d-flex flex-column'>
                <div className='bdr-top bdr-btm'>
                    {/* Azeem k :09-11-2023 :code commented as per discussion with akshay square off will be remove code will remove later */}
                    {/* {bIsSquareOffButton && <Row Row className='g-0 py-2 popover-menu' onClick={handleSquareOffPosition}>
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-square-off icon-dark'></div>
                            <div className='font-regular font-size4 color-text ms-2'>Square Off</div>
                        </Col>
                    </Row>} */}
                    {bIsModifyButton && <Row className='g-0 py-2 popover-menu'>
                        <Col className='d-flex align-items-center' onClick={handleModifyOrder}>
                            <div className='icon-16 icon-edit icon-dark'></div>
                            <div className='font-regular font-size4 color-text ms-2'>Modify order</div>
                        </Col>
                    </Row>}
                    {bIsCancelButton && objRowDataFromGrid?.prodType !== ORDER_PRODUCT_TYPES.COVER && objRowDataFromGrid?.prodType !== ORDER_PRODUCT_TYPES.BRACKET && <Row Row className='g-0 py-2 popover-menu' onClick={handleCancelOrder}>
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-close icon-dark'></div>
                            <div className='font-regular font-size4 color-text ms-2'>Cancel order</div>
                        </Col>
                    </Row>}
                    {bIsReorderButton ? <Row className='g-0 py-2 popover-menu' onClick={handleReOrder}>
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-reorder icon-dark'></div> {/* Hari P: SAT-BT-120115: 08-12-23- UI Issue Fixed */}
                            <div className='font-regular font-size4 color-text ms-2'>Reorder</div>
                        </Col>
                    </Row> : null}
                    {/* Azeem K : 08-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start */}
                    {/* //Azeem K : 31-07-2025 : Hiding Cover and Bracket order for production --Start */}
                    {bISExitButton ? <Row className='g-0 py-2 popover-menu' onClick={handleExit}>
                        {/* //Azeem K : 31-07-2025 : Hiding Cover and Bracket order for production --End */}
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-exit icon-dark'></div>
                            <div className='font-regular font-size4 color-text ms-2'>Exit Order</div>
                        </Col>
                    </Row> : null}
                    {/* Azeem K : 08-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - End */}
                    {bIsConvertPositionButton ? <Row className='g-0 py-2 popover-menu' onClick={handleConvertPosition} >
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-convert icon-dark'></div>
                            <div className='font-regular font-size4 color-text ms-2'>Convert Position</div>
                        </Col>
                    </Row> : null}
                    {bIsExpandButton ? <Row className='g-0 py-2 popover-menu' onClick={showTradeInfo.bind(this, objRowDataFromGrid?.orderNo)}>
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-info icon-dark me-2'></div>
                            {activeContent === ORDER_TYPES.GOOD_TILL_DATE ? 'Order History' : 'Trade Information'}
                        </Col>
                    </Row> : null}
                    <Row className='g-0 py-2 popover-menu' onClick={handleOverview}>
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-overview icon-dark'></div>
                            <div className='font-regular font-size4 color-text ms-2'>Overview</div>
                        </Col>
                    </Row>
                    {
                        objCFT.ALERT === FACILITY_NUM.ON ?
                            <Row className='g-0 py-2 popover-menu' onClick={handleSetAlert}>
                                <Col className='d-flex align-items-center'>
                                    {/* ManasaB : 23/11/2023 : BT-115296 Calculator Bug Fixing - Start */}
                                    <>
                                        <div className='icon-16 icon-bell icon-dark'></div>
                                        <div className='font-regular font-size4 color-text ms-2'>Set Alerts</div>
                                    </>
                                </Col>
                                {/* ManasaB : 23/11/2023 : BT-115296 Calculator Bug Fixing - End */}
                            </Row> : null
                    }
                </div>
                <div className='px-2 pb-2'>
                    {currentHolding?.length > 0 && <Row className='g-0 py-2 cursor-pointer'>
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-portfolio icon-dark'></div>
                            <div className='font-regular font-size3 color-text ms-2'>{currentHolding[0]?.TOTALFREEQUANTITY}</div>
                            {/* Azeem K : 16-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start  */}
                            <div className='font-regular font-size3 color-text ms-2'>{(holdingInfo?.length) ? <span className={`font-regular font-size3 color-text ${holdingInfo[2]}`}>&#8377;{`${Number(holdingInfo[0])?.toLocaleString('en-IN', { minimumFractionDigits: 2 })}(${holdingInfo[1]})`}</span> : null}</div>
                            {/* Azeem K : 16-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End  */}

                        </Col>
                    </Row>}
                    {objRowDataFromGrid?.dontMiss?.length > 0 &&
                        <Row className='g-0 py-2'>
                            <Col className='d-flex align-items-center'>
                                <div className='icon-16 icon-dontmiss icon-yellow'></div>
                                <div className='chips-wrap ms-2'>
                                    <DontMissChip value={objRowDataFromGrid.dontMiss} />
                                </div>
                            </Col>
                        </Row>}
                </div>
            </Popover.Body>
        </Popover>

    );
    return (
        // Azeem K : 15-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
        <BzPopoverOverlay show={showPopover} rootClose trigger='click' placement={placement} popover={BzPopover} onToggle={() => setShowPopover(false)}>
            {/* Azeem K : 15-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End */}

            {/* Vinit Raut : 28-11-2023 : BT-102298 - Breeze - NSECDS UI fixes -- Start */}
            {/* ManasaB : 13-06-2024 : Changed to left click in grid : Start */}
            <div className='scrip-wrap text-center' ref={targetobjRowData} onClick={onContextMenu}>{children}</div>
            {/* ManasaB : 13-06-2024 : Changed to left click in grid : End */}
            {/* Vinit Raut : 28-11-2023 : BT-102298 - Breeze - NSECDS UI fixes -- End */}
        </BzPopoverOverlay>
    );

};
export default memo(OrdersPopover);